import { DatePicker, DayOfWeek } from '@fluentui/react';
import React, { useMemo } from 'react';

const ProfileDatePicker = (props) => {

    const {
        datePickerProps = {},
        id = undefined
    } = props;
    const { disabled, isRequired, onSelectDate, value } = datePickerProps;

    const styles = useMemo(
        () => {
            let styles = {
                root: {
                    fontWeight: 400,
                    fontSize: 14,
                    lineHeight: "18px",
                },
                wrapper: {
                    selectors: {
                        "& .ms-TextField-fieldGroup": {
                            background: disabled ? "#FAFAFA !important" : "white !important",
                            border: disabled ? "1px solid #DBDBDB !important" : "1px solid black !important",
                            borderRadius: 3,
                            height: 32,
                        },
                        "& .ms-TextField-field": {
                            color: "black",
                            background: "transparent",
                            paddingTop: 2
                        },
                        "& label": {
                            color: disabled ? "#D9D9D9" : "black",
                            fontWeight: disabled ? 700 : 400,
                            fontSize: 14,
                            lineHeight: "18px",
                            textTransform: "uppercase",
                        },
                        "& [aria-live='assertive']": { margin: 0 } // Description
                    }
                },
            };

            return styles;
        },
        [disabled]
    );

    return <DatePicker
        {...datePickerProps}
        ariaLabel={isRequired && "Ce champ est obligatoire."}
        firstDayOfWeek={DayOfWeek.Monday}
        formatDate={date => date.toLocaleDateString("fr-FR")}
        id={id}
        onSelectDate={date => onSelectDate(new Date(date).toISOString())}
        placeholder="-"
        strings={{
            months: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
            shortMonths: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aou", "Sep", "Oct", "Nov", "Dec"],
            days: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
            shortDays: ["D", "L", "M", "M", "J", "V", "S"],
            Valider: "Valider",
            goToToday: "Aller à aujourd'hui",
            prevMonthAriaLabel: "Aller au mois précédent",
            nextMonthAriaLabel: "Aller au mois suivant",
            prevYearAriaLabel: "Aller à l'année précédente",
            nextYearAriaLabel: "Aller à l'année suivante",
            closeButtonAriaLabel: "Fermer le date picker",
            isRequiredErrorMessage: "La date est obligatoire",
            invalidInputErrorMessage: "Format de date invalide"
        }}
        styles={styles}
        value={!!value ? new Date(value) : value}
    />;

};

export default ProfileDatePicker;